import { apiWrapper } from "@/services/api";
import store from "@/store";

export const getPaymentMethodsForMasterBook = async (master_book_id) => {
  let response;
  try {
    response = await apiWrapper(
      "GET",
      "authorization-methods?type=master_book&master_book_id=" +
        master_book_id +
        "&include_payment=true",
      {},
      false,
      null
    );
    store.commit("ticketing/setPaymentMethods", response.data);
    return response.data;
  } catch (err) {
    console.log('ERROR"" getPaymentMethodsForMasterBook():', err);
    throw err;
  }
};
